export default (() => {

    function reverseString (value) {
        if (typeof value !== 'string') {
            return wealthify.error.throwError('convert.reverseString', 'value must be of type string');
        }

        return value.split('').reverse()
            .join('');
    }

    function toJson (value) {
        if (typeof value !== 'string') {
            return wealthify.error.throwError('convert.toJson', 'value must be of type string');
        }

        // Remove spaces from value

        const zeroOrMoreSpacesInObjectConstruction = /\s*([:{},])(?=(?:[^']*'[^']*')*[^']*$)\s*/g;

        value = value.replace(zeroOrMoreSpacesInObjectConstruction, '$1');

        // Objects using single quotes, or no quotes at all
        // must be updated to use double quote to follow JSON format

        // Use of single quotes for object construction vs apostrophes can be differentiated
        // by either the proceding or the succeeding character being [:{}]
        // e.g. Object: {'key':'value'}
        //      Apostrophe: James' | can't | Barker's | 'quote'
        /* eslint-disable no-useless-escape */
        const precedingQuoteInObjectContruction = /([:{},\[\]])'/g;
        const succeedingQuoteInObjectContruction = /'([:{},\[\]])/g;
        const propertyWithoutQuotes = /([{,])([-a-zA-Z]+):/g;

        value = value.replace(precedingQuoteInObjectContruction, '$1"');
        value = value.replace(succeedingQuoteInObjectContruction, '"$1');
        value = value.replace(propertyWithoutQuotes, '$1"$2":');

        let formattedValue;

        try {
            formattedValue = JSON.parse(value);
        } catch (error) {
            return wealthify.error.throwError('convert.toJson', `value (${value}) was unable to be converted to a JSON`);
        }

        return formattedValue;
    }

    function casing (value) {
        // Convert between kebab and casing, and vice versa
        const isCamelCaseFlag = isCamelCase(value);
        const isKebabCaseFlag = isKebabCase(value);

        if (isCamelCaseFlag && !isKebabCaseFlag) {
            return toKebabCase(value);
        } else if (isKebabCaseFlag && !isCamelCaseFlag) {
            return toCamelCase(value);
        }

        return value;
    }

    function toCamelCase (value) {
        if (typeof value !== 'string') {
            return wealthify.error.throwError('convert.toCamelCase', 'value must be of type string');
        }

        const isCamelCaseFlag = isCamelCase(value);
        const isKebabCaseFlag = isKebabCase(value);
        const hasSpaces = isSpaceSeparated(value);
        const hasHyphens = value.includes('-');

        if (isCamelCaseFlag || (!isCamelCaseFlag && !isKebabCaseFlag && !hasSpaces) || (hasSpaces && hasHyphens)) {
            return value;
        }

        const parts = isKebabCaseFlag && !hasSpaces
            ? _getKebabCaseParts(value)
            : _getSpaceSeparatedParts(value);

        const formattedParts = parts.map((part, index) => {
            if (index === 0) {
                return part.toLowerCase();
            }

            return part.charAt(0).toUpperCase() + part.substr(1).toLowerCase();
        });

        return formattedParts.join('');
    }

    function toKebabCase (value) {
        if (typeof value !== 'string') {
            return wealthify.error.throwError('convert.toKebabCase', 'value must be of type string');
        }

        const isCamelCaseFlag = isCamelCase(value);
        const isKebabCaseFlag = isKebabCase(value);
        const hasSpaces = isSpaceSeparated(value);
        const hasHyphens = value.includes('-');

        if (isKebabCaseFlag || (!isCamelCaseFlag && !isKebabCaseFlag && !hasSpaces) || (hasSpaces && hasHyphens)) {
            return value;
        }

        const parts = isCamelCaseFlag && !hasSpaces
            ? _getCamelCaseParts(value)
            : _getSpaceSeparatedParts(value);

        const formattedParts = parts.map((part, index) => {
            if (index === 0) {
                return part.toLowerCase();
            }

            return '-' + part.toLowerCase();
        });

        return formattedParts.join('');
    }

    function isCamelCase (value) {
        return _getCamelCaseParts(value)?.length > 1;
    }
      
    function isKebabCase (value) {
        return _getKebabCaseParts(value)?.length > 1;
    }

    function isSpaceSeparated (value) {
        return _getSpaceSeparatedParts(value).length > 1;
    }

    function _getCamelCaseParts (value) {
        if (value.includes(' ')) {
            return null;
        }

        return value.match(/^[a-z]+|[A-Z][a-z]+|[A-Z]+/g);
    }

    function _getKebabCaseParts (value) {
        if (value.includes(' ')) {
            return null;
        }
        
        return value.split('-');
    }

    function _getSpaceSeparatedParts (value) {
        return value.split(' ');
    }

    return {
        reverseString,
        toJson,
        casing,
        toCamelCase,
        toKebabCase,
        isCamelCase,
        isKebabCase
    };

})();